export const BACKEND_URL =
  process.env.NODE_ENV === "production"
    ? "https://climatebot.herokuapp.com/api"
    : "http://localhost:1337/api";

export const PRICE = 1;
export const PRICE_LIFETIME = 2;
export const PRICE_DIRECT = 1;